module.exports = __webpack_public_path__ + "static/media/icon-delete.fa3821bb.svg";